module.exports = __webpack_public_path__ + "img/zhuantihuodong.a3aa5d89.png";